import React, { useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import { AgGridReact } from 'ag-grid-react';
import 'ag-grid-community/styles/ag-grid.css';
import 'ag-grid-community/styles/ag-theme-material.css';
import ImageCellRendererDeviceEvents from './CustomCells/ImageCellRendererDeviceEvents';

export interface TableComponentProps {
  data?: any;
  searchVal?: string;
  openModal?: Function;
  getFilteredData?: Function;
}

const TableComponent: React.FC<TableComponentProps> = ({ data, searchVal, openModal,getFilteredData }) => {

  const [columns, setColumns] = useState<any>([]);
  const [rows, setRows] = useState<any>([]);
  const [allRows, setAllRows] = useState<any>([]);
  const [original, setOriginal] = useState<any>([]);

  const DefaultColumns = [ 
    { field: 'Device ID', resizable: true, sortable: true },
    { field: 'Service Provider Name', resizable: true, sortable: true },
    { field: 'Segment Name', resizable: true, sortable: true },
    { field: 'RFID Tag', resizable: true, sortable: true },
    { field: 'Truck Number', resizable: true, sortable: true },
    { field: 'Event Name', resizable: true, sortable: true },
    { field: 'Event Timestamp', resizable: true,sortable: true },
    { field: 'Event Time (SP timezone)', resizable: true, sortable: true },
    { field: 'Received Timestamp', resizable: true, sortable: true },
    { field: 'Longitude', resizable: true, sortable: true },
    { field: 'Latitude', resizable: true, sortable: true },
    { field: 'Address', resizable: true, sortable: true },
    { field: 'Observation Number', resizable: true, sortable: true },
    { field: 'Observation Description', resizable: true, sortable: true },
    { field: 'Image Url', resizable: true, sortable: true },
    { field: 'Image-2 Url', resizable: true, sortable: true }
  ];

  var dateFilterParams = {
    comparator: function (filterLocalDateAtMidnight: any, cellValue: any) {
      var dateAsString = cellValue;
      if (dateAsString == null) return -1;
      var dateParts = dateAsString.split('/');
      var cellDate = new Date(
        Number(dateParts[2].includes(',') ? dateParts[2].split(',')[0] : dateParts[2].split(' ')[0]),
        Number(dateParts[0]) - 1,
        Number(dateParts[1])
      );
      if (filterLocalDateAtMidnight.getTime() === cellDate.getTime()) {
        return 0;
      }
      if (cellDate < filterLocalDateAtMidnight) {
        return -1;
      }
      if (cellDate > filterLocalDateAtMidnight) {
        return 1;
      }
      return 0;
    },
    minValidYear: 2000,
    maxValidYear: new Date().getFullYear()
  };

  // filters table for when user types in search value
  useEffect(() => {
    if (searchVal && searchVal !== "") {
        let daraRows = [...allRows];
      let newRows = daraRows.filter((r: any) => JSON.stringify(r).toLowerCase().includes(searchVal.toLowerCase()));
      setRows(newRows);
    } else {
      setRows(original);
    }
  }, [searchVal]);

  // grabs data and sets columns and rows for mui data grid
  useEffect(() => {
    if (data && data.length > 0) {
      let flatData = data.map((item: any) => ({ ...item.data, ...item }));
      //console.log(flatData);
      if (flatData.metadata) {
        flatData = flatData.map((item: any) => ({ ...item.metadata, ...item }));
      }
      let keys = Object.keys(flatData[0]);

      let newRows = [];
      let newKeys = [];

      // rows
      for (let z = 0; z < flatData.length; z++) {
        let newRow = {
          ...flatData[z],
        }
        newRows.push(newRow);
      }

      // columns
      for (let i = 0; i < keys.length; i++) {
        let obj: any = null;
        
        if (keys[i] === "hostName") {
          obj = { headerName: 'Device ID', field: keys[i] }
        }
        else if (keys[i] === "serviceProviderName") {
          obj = { headerName: 'Service Provider Name', field: keys[i], width: 220  }
        }
        else if (keys[i] === "truckSegmentName") {
          obj = { headerName: 'Segment Name', field: keys[i] }
        }
        else if (keys[i] === "rfidTag") {
          obj = { headerName: 'RFID Tag', field: keys[i] }
        }
        else if (keys[i] === "truckNo") {
          obj = { headerName: 'Truck Number', field: keys[i]}
        }
        else if (keys[i] === "eventName") {
          obj = { headerName: 'Event Name', field: keys[i] }
        }
        else if (keys[i] === "latitude") {
          obj = { headerName: 'Latitude', field: keys[i] }
        }
        else if (keys[i] === "longitude") {
          obj = { headerName: 'Longitude', field: keys[i] }
        }
        else if (keys[i] === "serviceProviderEventTimestamp") {
           obj = { headerName: 'Event Time (SP timezone)', field: keys[i],width: 235, filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "eventTimestamp") {
          obj = { headerName: 'Event Timestamp', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "receivedTimestamp") {
          obj = { headerName: 'Recieved Timestamps', field: keys[i], filter: 'agDateColumnFilter', filterParams: dateFilterParams }
        }
        else if (keys[i] === "address") {
          obj = { headerName: 'Address', field: keys[i]}
        }
        else if (keys[i] === "obsNumber") {
            obj = { headerName: 'Observation Number', field: keys[i]}
        }
        else if (keys[i] === "obsDesc") {
            obj = { headerName: 'Observation Description', field: keys[i]}
        }
        else if (keys[i] === "imageUrl") {
          obj = {
            field: keys[i], minWidth: 300,
                cellRendererSelector: (params: any) => {
              return { component: ImageCellRendererDeviceEvents }
            },
                cellRendererParams: openModal ?
                    {
                        editAction: (modal: any, user: any) => openModal(modal)
                    } :
                    {}
            }
        }
        else if (keys[i] === "imageUrl2") {
          obj = {
            headerName: 'Image-2 Url',
            field: keys[i], minWidth: 300,
                cellRendererSelector: (params: any) => {
              return { component: ImageCellRendererDeviceEvents }
            },
                cellRendererParams: openModal ?
                    {
                        editAction: (modal: any, user: any) => openModal(modal)
                    } :
                    {}
            }
        }
        if (obj) {
          if (keys[i] === "hostName")
              newKeys.unshift(obj);
          else
              newKeys.push(obj);
            }
      }

      setColumns(newKeys);
      setRows(newRows);
      setOriginal(newRows);
      setAllRows(newRows);
    }
    else {
      setRows([]);
      setOriginal([]);
      setColumns(DefaultColumns);
      setAllRows([]);
    }
  }, [data]);

  const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true
  };

      // Downloading Only Filtered Data After Search
      useEffect(() => {
        if (getFilteredData)
          getFilteredData(rows);
      },[rows]);


  return (
    <Box className="ag-theme-material" sx={{ height: "75%", width: '100%' }}>
      <AgGridReact
        rowData={rows}
        columnDefs={columns}
        pagination={true}
        paginationPageSize={200}
        suppressHorizontalScroll={false}
        rowSelection={"single"}
        rowHeight={40}
        headerHeight={35}    
        defaultColDef={defaultColDef}
        enableRangeSelection={true}
      >
      </AgGridReact>
    </Box>
  );
}

export default TableComponent;